/**
 * Marketing header above the form.
 *
 * NO JUMP-TO-FORM BUTTON. There used to be a "Get Started Today" CTA here that scrolled to the
 * first field. Neither artboard draws one, and on this layout it had nothing to do: the form
 * begins immediately below the hero and is already visible without scrolling, so the button
 * asked for a click to reach something the customer could simply look at.
 *
 * That removal is why this component takes no props. If a jump target is ever wanted again, pass
 * the behavior in as a callback rather than reaching into the document from here.
 *
 * FULL WIDTH AND CENTRED, which is a departure from both artboards -- they draw this band
 * left-aligned inside a 620px column. Two things follow from dropping the column: the headline
 * gets the whole container to work with, so at desktop widths it sets on one line instead of
 * wrapping to two, and there is no longer an eyebrow above it ("New website signup") competing
 * for the top-left corner.
 *
 * The progress indicator the desktop artboard draws beside this ("2 of 4 done") is deliberately
 * absent, by an earlier decision.
 */
export default function CheckoutHero() {
  return (
    <div className="border-b border-gray-200 px-4 py-6 text-center sm:px-7 sm:py-8">
      <h1 className="text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
        You&rsquo;re this close to an awesome online presence.
      </h1>

      <p className="mt-2 text-sm leading-relaxed text-gray-600">
        Four sections, about two minutes. Nothing is charged until you review at Stripe.
      </p>
    </div>
  );
}
